import React, { useEffect, useState } from 'react'
import { useAuth } from '~/routes/components/AuthProvider'
import { useDebounce } from 'use-lodash-debounce'
import { Dimmer, Icon, Input, Loader } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import ProfileSettingsService from '~/api/services/profileSettings'
import { handleErrors } from '~/utils/helpers'
import { StyledWrapper } from './style'

export enum LabelTwoFaType {
  Inline = 'inlineLabel',
  Top = 'topLabel',
}

interface TwoFaCompProps {
  onChangeCorrectTfaCode: (correctTFa: boolean) => void
  onChangeTfaCode: (code: string) => void
  disableMarginTop?: boolean
  type?: LabelTwoFaType
}

const TwoFaComp: React.FC<TwoFaCompProps> = (props) => {
  const { systemData } = useAuth()
  const { t } = useTranslation()
  const tfaType = systemData?.logged?.tfaType
  const [correctTfaCode, setCorrectTfaCode] = useState(false)
  const [tfaCode, setTfaCode] = useState('')
  const [loadingTfaCode, setLoadingTfaCode] = useState(false)
  const codeValue = useDebounce(tfaCode, 300);

  useEffect(() => {
    if (codeValue !== '') {
      checkCode(codeValue)
    }
  }, [codeValue])

  async function checkCode(value) {
    setLoadingTfaCode(true)
    try {
      const response = await ProfileSettingsService.checkCode({ code: value })
      setCorrectTfaCode(response.data === 1)
      props.onChangeCorrectTfaCode(response.data === 1)
      if (response.data === 1) {
        props.onChangeTfaCode(value)
      }
    } catch (error) {
      handleErrors(error)
    }
    setLoadingTfaCode(false)
  }

  function getVerificationLabel() {
    switch (tfaType) {
      case 'email':
        return t('E-mail')
      case 'sms':
        return t('SMS')
      case 'google':
        return t('Authenticator')
      default:
        return ''
    }
  }

  function renderTfaCodeAuth() {
    const verificationLabel = getVerificationLabel()
    return <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', minWidth: 400 }}>
      <Input
        placeholder={t('Enter code')}
        label={t('Enter 2FA code ({{verificationLabel}})', { verificationLabel })}
        value={tfaCode}
        style={{ marginTop: props?.disableMarginTop ? 0 : 20 }}
        onChange={(e, data) => setTfaCode(data.value)}
      />
      <div style={{ position: 'relative', margin: 'auto', marginLeft: 10, marginTop: props?.disableMarginTop ? 3 : 23, marginRight: 5 }}>
        {loadingTfaCode && <Dimmer inverted active={loadingTfaCode}>
          <Loader size='small' active={loadingTfaCode} />
        </Dimmer>}
      </div>
      {!loadingTfaCode && <Icon
        style={{ marginLeft: props?.disableMarginTop ? 0 : 10 }}
        name={correctTfaCode ? 'checkmark' : 'close'}
        color={correctTfaCode ? 'green' : 'red'}
      />}
    </div>
  }

  function renderTfaCodeLabelTop() {
    const verificationLabel = getVerificationLabel()
    return <StyledWrapper>
      <label style={{ display: 'flex', position: 'relative', marginBottom: 5 }}>
        <div style={{ color: '#5e6672' }}>{t('Enter 2FA code ({{verificationLabel}})', { verificationLabel })}<span style={{ color: 'red' }}>*</span>:</div>
        {loadingTfaCode && <div className='loaderWrapper'>
          <Dimmer inverted active={loadingTfaCode}>
            <Loader size='small' active={loadingTfaCode} />
          </Dimmer>
        </div>}
        {!loadingTfaCode && tfaCode !== '' && <Icon
          style={{ marginLeft: 10 }}
          name={correctTfaCode ? 'checkmark' : 'close'}
          color={correctTfaCode ? 'green' : 'red'}
        />}
      </label>
      <Input
        placeholder={t('Enter code')}
        value={tfaCode}
        style={{ marginTop: props?.disableMarginTop ? 0 : 20, width: 230 }}
        onChange={(e, data) => setTfaCode(data.value)}
      />
    </StyledWrapper>
  }

  switch (props.type) {
    case LabelTwoFaType.Inline:
      return <>
        {renderTfaCodeAuth()}
      </>
    case LabelTwoFaType.Top:
      return <>
        {renderTfaCodeLabelTop()}
      </>
    default:
      return <>
        {renderTfaCodeAuth()}
      </>
  }
}
export default TwoFaComp